var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 481,
    viewBox: "0 0 492 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_355)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.1122,
    y: 112.028,
    width: 390.972,
    height: 240.598,
    rx: 22.5561,
    fill: "#6E44FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.6681,
    y: 81.9537,
    width: 345.86,
    height: 248.117,
    rx: 15.0374,
    fill: "#FB9C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.43 175.889C288.871 175.889 285.161 174.67 282.299 172.232C279.437 169.688 278.005 166.295 278.005 162.055C278.005 157.92 279.437 154.581 282.299 152.037C285.267 149.493 288.977 148.221 293.43 148.221C297.988 148.221 301.699 149.493 304.561 152.037C307.423 154.581 308.854 157.92 308.854 162.055C308.854 166.295 307.423 169.688 304.561 172.232C301.699 174.67 297.988 175.889 293.43 175.889ZM280.232 275.591V188.769H306.787V275.591H280.232Z",
    fill: "white",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.172 275.591L199.109 161.419H230.753L266.372 275.591H238.386L231.389 248.241H197.36L190.205 275.591H163.172ZM226.301 228.364L223.598 217.71C222.113 212.621 220.629 206.791 219.145 200.218L214.534 182.886H213.739C213.315 185.218 212.573 188.61 211.513 193.063C210.664 196.243 210.081 198.628 209.763 200.218L205.152 217.71L202.29 228.364H226.301Z",
    fill: "white",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.229 136.464C293.229 141.655 289.021 145.863 283.83 145.863C278.64 145.863 274.432 141.655 274.432 136.464C274.432 131.274 278.64 127.066 283.83 127.066C289.021 127.066 293.229 131.274 293.229 136.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.229 196.614C293.229 201.804 289.021 206.012 283.83 206.012C278.64 206.012 274.432 201.804 274.432 196.614C274.432 191.423 278.64 187.215 283.83 187.215C289.021 187.215 293.229 191.423 293.229 196.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.387 175.937C311.577 175.937 315.785 171.73 315.785 166.539C315.785 161.348 311.577 157.141 306.387 157.141C301.196 157.141 296.988 161.348 296.988 166.539C296.988 171.73 301.196 175.937 306.387 175.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.063 136.464C327.063 141.655 322.855 145.863 317.665 145.863C312.474 145.863 308.266 141.655 308.266 136.464C308.266 131.274 312.474 127.066 317.665 127.066C322.855 127.066 327.063 131.274 327.063 136.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.665 206.012C322.855 206.012 327.063 201.804 327.063 196.614C327.063 191.423 322.855 187.215 317.665 187.215C312.474 187.215 308.266 191.423 308.266 196.614C308.266 201.804 312.474 206.012 317.665 206.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.619 166.539C349.619 171.73 345.411 175.937 340.221 175.937C335.03 175.937 330.822 171.73 330.822 166.539C330.822 161.348 335.03 157.141 340.221 157.141C345.411 157.141 349.619 161.348 349.619 166.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.499 145.863C356.689 145.863 360.897 141.655 360.897 136.464C360.897 131.274 356.689 127.066 351.499 127.066C346.308 127.066 342.1 131.274 342.1 136.464C342.1 141.655 346.308 145.863 351.499 145.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.897 196.614C360.897 201.804 356.689 206.012 351.499 206.012C346.308 206.012 342.1 201.804 342.1 196.614C342.1 191.423 346.308 187.215 351.499 187.215C356.689 187.215 360.897 191.423 360.897 196.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.055 175.937C379.245 175.937 383.453 171.73 383.453 166.539C383.453 161.348 379.245 157.141 374.055 157.141C368.864 157.141 364.656 161.348 364.656 166.539C364.656 171.73 368.864 175.937 374.055 175.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.019 306.731C359.345 309.35 359.345 313.197 357.019 315.816C343.546 330.986 296.529 378.942 240.598 378.942C184.667 378.942 137.65 330.986 124.177 315.816C121.851 313.197 121.852 309.35 124.177 306.731C137.65 291.562 184.667 243.605 240.598 243.605C296.529 243.605 343.546 291.562 357.019 306.731Z",
    fill: "url(#paint0_linear_52_355)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.598,
    cy: 311.274,
    r: 45.1121,
    fill: "url(#paint1_linear_52_355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.598 341.348C257.208 341.348 270.673 327.884 270.673 311.274C270.673 309.749 270.353 307.735 269.96 305.838C269.402 303.139 266.11 302.171 263.718 303.539C262.061 304.487 260.225 305.259 258.643 305.259C251.999 305.259 246.613 299.873 246.613 293.229C246.613 291.633 246.924 290.11 247.488 288.717C248.61 285.944 248.026 281.969 245.067 281.529C243.609 281.311 242.117 281.199 240.598 281.199C223.988 281.199 210.523 294.664 210.523 311.274C210.523 327.884 223.988 341.348 240.598 341.348Z",
    fill: "#6E44FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.967 393.979C187.967 398.132 184.601 401.498 180.449 401.498C176.296 401.498 172.93 398.132 172.93 393.979C172.93 389.827 176.296 386.461 180.449 386.461C184.601 386.461 187.967 389.827 187.967 393.979ZM248.117 412.776C248.117 416.928 244.75 420.295 240.598 420.295C236.446 420.295 233.079 416.928 233.079 412.776C233.079 408.624 236.446 405.257 240.598 405.257C244.75 405.257 248.117 408.624 248.117 412.776ZM300.748 401.498C304.9 401.498 308.266 398.132 308.266 393.979C308.266 389.827 304.9 386.461 300.748 386.461C296.595 386.461 293.229 389.827 293.229 393.979C293.229 398.132 296.595 401.498 300.748 401.498Z",
    fill: "url(#paint2_linear_52_355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.187 115.788C102.404 115.788 99.3376 118.854 99.3376 122.637V136.336C99.3376 140.119 102.404 143.186 106.187 143.186H119.886C123.669 143.186 126.735 140.119 126.735 136.336V122.637C126.735 118.854 123.669 115.788 119.886 115.788H106.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.264 117.5C193.582 115.217 196.878 115.217 198.196 117.5L210.059 138.049C211.378 140.332 209.73 143.186 207.094 143.186H183.366C180.73 143.186 179.082 140.332 180.4 138.049L192.264 117.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.071 162.356C111.389 160.073 114.684 160.073 116.002 162.356L127.866 182.905C129.184 185.188 127.536 188.042 124.9 188.042H101.173C98.5365 188.042 96.8888 185.188 98.207 182.905L110.071 162.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.434 167.493C140.434 163.71 143.501 160.644 147.284 160.644H160.983C164.766 160.644 167.832 163.71 167.832 167.493V181.192C167.832 184.975 164.766 188.042 160.983 188.042H147.284C143.501 188.042 140.434 184.975 140.434 181.192V167.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.133 143.186C161.699 143.186 167.832 137.052 167.832 129.487C167.832 121.921 161.699 115.788 154.133 115.788C146.567 115.788 140.434 121.921 140.434 129.487C140.434 137.052 146.567 143.186 154.133 143.186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.832 219.711C167.832 227.277 161.699 233.41 154.133 233.41C146.567 233.41 140.434 227.277 140.434 219.711C140.434 212.145 146.567 206.012 154.133 206.012C161.699 206.012 167.832 212.145 167.832 219.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23 188.042C202.796 188.042 208.929 181.908 208.929 174.343C208.929 166.777 202.796 160.644 195.23 160.644C187.664 160.644 181.531 166.777 181.531 174.343C181.531 181.908 187.664 188.042 195.23 188.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.766 249.655C429.221 249.655 449.856 223.861 449.856 192.042C449.856 223.861 470.492 249.655 495.947 249.655C470.492 249.655 449.856 275.45 449.856 307.269C449.856 275.45 429.221 249.655 403.766 249.655Z",
    fill: "#FB9C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.417 320.694C61.2418 320.694 70.017 309.725 70.017 296.194C70.017 309.725 78.7922 320.694 89.617 320.694C78.7922 320.694 70.017 331.663 70.017 345.194C70.017 331.663 61.2418 320.694 50.417 320.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.32 105.004L244.32 228.472",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_355",
    x1: 240.598,
    y1: 243.605,
    x2: 240.598,
    y2: 382.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#D0C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A185FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_355",
    x1: 285.71,
    y1: 311.274,
    x2: 195.486,
    y2: 311.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_52_355",
    x1: 240.598,
    y1: 375.183,
    x2: 236.852,
    y2: 419.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 492,
    height: 481,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddle1);
export default __webpack_public_path__ + "static/media/middle1.a66bc3448416c3c7a4272825b4418aee.svg";
export { ForwardRef as ReactComponent };